/**
 * `room:kicked`: the seat moved to another tab ("Use this tab" takes it back)
 * or the room was closed by the server.
 */
import type { KickedPayload } from '@wordloom/engine';
import { leave, reclaimSeat } from '../net/session';
import { IconDoor, IconTabs } from './Icons';

export function KickedScreen({ kicked }: { kicked: KickedPayload }) {
  const replaced = kicked.reason === 'replaced';
  return (
    <main className="screen-center">
      <section className="card notice" aria-labelledby="kicked-title">
        <span className="notice__icon" aria-hidden="true">
          {replaced ? <IconTabs /> : <IconDoor />}
        </span>
        <h1 id="kicked-title">{replaced ? 'This game is open in another tab' : 'This room has closed'}</h1>
        <p>
          {replaced
            ? 'You can only play from one tab at a time. Switch back to the other tab, or continue here.'
            : kicked.message}
        </p>
        <div className="notice__actions">
          {replaced && (
            // autoFocus: this notice replaces the whole screen, so focus belongs here.
            <button type="button" className="btn btn--primary" autoFocus onClick={reclaimSeat}>
              Use this tab
            </button>
          )}
          <button
            type="button"
            className="btn"
            autoFocus={!replaced}
            onClick={() => leave({ forget: !replaced })}
          >
            Back to lobby
          </button>
        </div>
      </section>
    </main>
  );
}
